import onetime from "@-/com.npmjs.onetime";
import { getStorage } from "@-/dev.improve.haniverse.lib.storage";
import { createQueryCachePersisters } from "#create-query-cache-persisters";

export const queryCachePersisters = onetime(() =>
  createQueryCachePersisters({
    storage: {
      getItem: (key) => getStorage().getString(key) ?? null,
      getKeys: () => getStorage().getAllKeys(),
      removeItem: (key) => {
        getStorage().remove(key);
      },
      setItem: (key, value) => getStorage().set(key, value),
    },
  }),
);
